var schleswigHolsteinQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Schleswig-Holstein?',
    image: '441',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Schleswig-Holstein?',
    answers: [
      {
        content: 'Ammerland',
        key: 0,
      },
      {
        content: 'Demmin',
        key: 0,
      },
      {
        content: 'Nordfriesland',
        key: 1,
      },
      {
        content: 'Rhein-Sieg-Kreis',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Schleswig-Holstein gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Schleswig-Holstein bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Schleswig-Holstein?',
    answers: [
      {
        content: 'weiß-blau',
        key: 0,
      },
      {
        content: 'blau-weiß-rot',
        key: 1,
      },
      {
        content: 'weiß-rot',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Schleswig-Holstein über politische Themen informieren?',
    answers: [
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Schleswig-Holstein heißt...',
    answers: [
      {
        content: 'Husum.',
        key: 0,
      },
      {
        content: 'Flensburg.',
        key: 0,
      },
      {
        content: 'Lübeck.',
        key: 0,
      },
      {
        content: 'Kiel.',
        key: 1,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Schleswig-Holstein?',
    image: '448',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Schleswig-Holstein?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Schleswig-Holstein',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Schleswig-Holstein nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Schleswig-Holstein',
  },
]

export default schleswigHolsteinQuestions
